<template>
  <div
    class="firstPage"
    :class="[
      props.siteId !== siteEnum.IND &&
        props.siteId !== siteEnum.IW2 &&
        props.siteId !== siteEnum.BR1
        ? ''
        : 'ind-firstPage',
      props.siteId !== siteEnum.LH1 ? '' : 'lh',
      props.siteId !== siteEnum.VNM ? '' : 'vi',
      props.siteId !== siteEnum.KRW ? '' : 'kr',
      props.siteId !== siteEnum.PAK ? '' : 'pak',
      props.siteId !== siteEnum.PH2 ? '' : 'ph2',
      props.siteId !== siteEnum.KAKA ? '' : 'kaka',
      props.siteId !== siteEnum.BR2 ? '' : 'br2',
      props.siteId !== siteEnum.LK6 ? '' : 'lk6',
      props.siteId !== siteEnum.AK2 ? '' : 'ak2'
    ]"
  >
    <img
      class="float-logo"
      :class="[
        props.siteId !== siteEnum.PH2 ? '' : 'ph2'
      ]"
      v-if="props.siteId === siteEnum.KAKA"
      :src="currentSite.logo"
    >
    <div class="inner">
      <div class="loginPage">
        <div v-if="props.siteId === siteEnum.PH2" class="left-pseudo" />
        <div class="left">
          <div class="logo">
            <img
              v-if="props.siteId !== siteEnum.KAKA"
              :src="currentSite.logo"
            >
          </div>
          <div
            class="first-liner"
            :class="[
              props.siteId !== siteEnum.LK6 ? '' : 'firstliner-lk6',
              props.siteId !== siteEnum.PH2 ? '' : 'ph2'
            ]"
            v-html="currentSite.firstLiner"
            :data-text="currentSite.firstLiner"
          />
          <div
            v-if="props.siteId === siteEnum.LK6"
            class="second-liner-wrapper"
          >
            <img
              class="second-liner-img"
              src="../../assets/images/lk6/affiliate-img.png"
            >
            <div class="second-liner-inner">
              <div
                class="second-liner"
                :data-text="currentSite.secondLiner"
                :class="[
                  props.siteId.toString() !== siteEnum.LK6
                    ? ''
                    : 'secondliner-lk6',
                ]"
              >
                {{ currentSite.secondLiner }}
              </div>
              <div class="second-liner-contact-info">
                <img
                  class="second-liner-contact-info__icon"
                  src="../../assets/images/lk6/telegram-icon.png"
                >
                <div class="second-liner-contact-info__text-wrapper">
                  <span>{{ $t('common.telegram_lk6') }}</span>
                  <a href="https://t.me/xy66vip" target="_blank">@xy66vip</a>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="second-liner" v-html="currentSite.secondLiner" />
          <div>
            <img
              v-if="props.siteId === siteEnum.BR2"
              src="../../assets/images/br2/br2-main-img.png"
              class="main-img"
            >
          </div>
        </div>
        <div class="right">
          <div class="bg swiper-no-swiping">
            <div class="top">
              <div class="log">
                {{ isReg ? $t('common.signup') : $t('common.login') }}
              </div>
              <LangToggle
                v-if="props.siteId === siteEnum.VNM"
                :langList="['vi', 'en']"
              />
              <LangToggle
                v-if="props.siteId === siteEnum.LK6"
                :langList="['zh', 'en']"
                variant="button"
              />
              <!--              <div class="topright" v-if="props.siteId !== '5'">-->
              <!--                <span class="noaccabs">-->
              <!--                  {{ isReg ? '已经有账号? ' : '没有帐户？' }}-->
              <!--                </span>-->
              <!--                <a @click="isReg = !isReg" class="signlog">-->
              <!--                  {{ isReg ? '请登录' : '立即注册' }}-->
              <!--                </a>-->
              <!--              </div>-->
            </div>

            <div class="mid">
              <img
                class="top-img"
                v-if="props.siteId === siteEnum.LH1"
                src="../../assets/images/login/lh-login-1.png"
              >
              <el-form
                v-if="!isReg"
                ref="loginFormRef"
                :model="loginForm"
                :rules="
                  props.siteId === siteEnum.VNM ? loginRulesVi : loginRules
                "
                class="login-form"
                autocomplete="no-fill"
                validate-on-rule-change="false"
              >
                <el-form-item
                  prop="userName"
                  :label="isLk6MobileView && $t('common.username')"
                >
                  <el-input
                    ref="userNameRef"
                    v-model="loginForm.userName"
                    :placeholder="$t('common.username')"
                    name="username"
                    type="text"
                    tabindex="1"
                    autocomplete="no-fill"
                  >
                    <template v-if="props.siteId === siteEnum.LK6" #prefix>
                      <div class="prefix-wrapper">
                        <img src="../../assets/images/lk6/account-icon.png">
                        <span>{{ $t('common.username') }}</span>
                      </div>
                      <img
                        class="prefix-icon"
                        src="../../assets/images/lk6/account-icon-mobile.png"
                      >
                    </template>
                  </el-input>
                </el-form-item>

                <el-tooltip
                  v-model="capsTooltip"
                  content="Caps lock is On"
                  placement="right"
                  manual
                >
                  <el-form-item
                    prop="password"
                    :label="isLk6MobileView && $t('common.password')"
                  >
                    <el-input
                      :key="passwordType"
                      ref="passwordRef"
                      v-model="loginForm.password"
                      :type="passwordType"
                      :placeholder="$t('common.password')"
                      name="password"
                      tabindex="2"
                      autocomplete="no-fill"
                      @keyup="checkCapslock"
                      @blur="capsTooltip = false"
                      @keyup.enter="
                        props.siteId !== siteEnum.VNM ? handleLogin() : null
                      "
                    >
                      <template v-if="props.siteId === siteEnum.LK6" #prefix>
                        <div class="prefix-wrapper">
                          <img
                            src="../../assets/images/lk6/password-icon.png"
                          >
                          <span>{{ $t('common.password') }}</span>
                        </div>
                        <img
                          class="prefix-icon"
                          src="../../assets/images/lk6/password-icon-mobile.png"
                        >
                      </template>
                    </el-input>
                  </el-form-item>
                </el-tooltip>
                <el-form-item
                  prop="captchaCode"
                  v-if="props.siteId === siteEnum.VNM"
                >
                  <el-input
                    v-model="loginForm.captchaCode"
                    :placeholder="$t('common.verificationcode')"
                    name="captchaCode"
                    type="text"
                    tabindex="7"
                    autocomplete="on"
                    @keyup.enter="handleLogin"
                    clearable
                  >
                    <template #append>
                      <img :src="captchaImg" @click="getCaptcha()">
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="props.siteId === siteEnum.XF1 || props.siteId === siteEnum.DY2 || props.siteId === siteEnum.LH1">
                  <div id="captchaContainer" />
                </el-form-item>
                <div class="forget-pw" v-if="props.siteId !== siteEnum.VNM">
                  <el-link type="primary" @click="forgetPasswordDialog">
                    {{ $t('common.forgetpass') }}
                  </el-link>
                </div>
                <div class="flex-c-center-div login-btn-grp">
                  <el-button
                    class="common-btn"
                    type="danger"
                    style="width:50%;"
                    @click.prevent="handleLogin"
                  >
                    {{ $t('common.loginnow') }}
                  </el-button>
                  <el-button
                    class="common-btn default-btn"
                    type="primary"
                    style="width:50%;"
                    @click="isReg = !isReg"
                    v-if="props.siteId !== siteEnum.BR2 && props.siteId !== siteEnum.AK2"
                  >
                    {{ $t('common.register_affi') }}
                  </el-button>
                </div>

                <template v-if="props.siteId !== siteEnum.LK6" />
                <div
                  v-if="
                    props.siteId !== siteEnum.IND &&
                      props.siteId !== siteEnum.VNM &&
                      props.siteId !== siteEnum.BR2 &&
                      props.siteId !== siteEnum.AK2 &&
                      props.siteId !== siteEnum.LK6 &&
                      props.siteId !== siteEnum.PH2
                  "
                  class="flex-c-center-div"
                >
                  <div class="contact-div" @click="swipeToContactUs">
                    {{ $t('common.contact_us') }}
                  </div>
                </div>
                <LhFeedback v-if="props.siteId === siteEnum.LH1" />
              </el-form>
              <el-form
                v-if="isReg"
                ref="regFormRef"
                :model="regForm"
                :rules="regRules"
                class="reg-form"
                autocomplete="on"
                validate-on-rule-change="false"
              >
                <div v-if="step === 1">
                  <el-form-item
                    prop="userName"
                    :label="isLk6MobileView && $t('common.affiliateaccount')"
                  >
                    <el-input
                      ref="userNameRef"
                      v-model="regForm.userName"
                      :placeholder="$t('common.affiliateaccount')"
                      name="userName"
                      type="text"
                      tabindex="1"
                      autocomplete="off"
                    >
                      <template v-if="props.siteId === siteEnum.LK6" #prefix>
                        <div class="prefix-wrapper">
                          <img src="../../assets/images/lk6/account-icon.png">
                          <span>{{ $t('common.affiliateaccount') }}</span>
                        </div>
                        <img
                          class="prefix-icon"
                          src="../../assets/images/lk6/account-icon-mobile.png"
                        >
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-tooltip
                    v-model="capsTooltip"
                    content="Caps lock is On"
                    placement="right"
                    manual
                  >
                    <el-form-item
                      prop="password"
                      :label="isLk6MobileView && $t('common.password')"
                    >
                      <el-input
                        :key="passwordType"
                        ref="passwordRef"
                        v-model="regForm.password"
                        :type="passwordType"
                        :placeholder="$t('common.password')"
                        name="password"
                        tabindex="2"
                        autocomplete="on"
                        @keyup="checkCapslock"
                        @blur="capsTooltip = false"
                      >
                        <template v-if="props.siteId === siteEnum.LK6" #prefix>
                          <div class="prefix-wrapper">
                            <img
                              src="../../assets/images/lk6/password-icon.png"
                            >
                            <span>{{ $t('common.password') }}</span>
                          </div>
                          <img
                            class="prefix-icon"
                            src="../../assets/images/lk6/password-icon-mobile.png"
                          >
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-tooltip>
                  <el-tooltip
                    v-model="capsTooltip"
                    content="Caps lock is On"
                    placement="right"
                    manual
                  >
                    <el-form-item
                      prop="confirmPwd"
                      :label="isLk6MobileView && $t('common.confirmpassword')"
                    >
                      <el-input
                        :key="passwordType"
                        ref="confirmPwdRef"
                        v-model="regForm.confirmPwd"
                        :type="passwordType"
                        :placeholder="$t('common.confirmpassword')"
                        name="password"
                        tabindex="3"
                        autocomplete="on"
                        @keyup="checkCapslock"
                        @blur="capsTooltip = false"
                      >
                        <template v-if="props.siteId === siteEnum.LK6" #prefix>
                          <div class="prefix-wrapper">
                            <img
                              src="../../assets/images/lk6/password-icon.png"
                            >
                            <span>{{ $t('common.confirmpassword') }}</span>
                          </div>
                          <img
                            class="prefix-icon"
                            src="../../assets/images/lk6/password-icon-mobile.png"
                          >
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-tooltip>
                  <el-form-item
                    prop="codeAffiliate"
                    v-if="props.siteId === siteEnum.KRW"
                  >
                    <el-input
                      ref="codeAffiliateRef"
                      v-model="regForm.codeAffiliate"
                      :placeholder="$t('fields.referralCode')"
                      name="codeAffiliate"
                      type="text"
                      tabindex="8"
                      autocomplete="on"
                    />
                  </el-form-item>
                  <el-form-item
                    prop="captchaCode"
                    :label="isLk6MobileView && $t('common.verificationcode')"
                  >
                    <el-input
                      ref="verificationRef"
                      v-model="regForm.captchaCode"
                      :placeholder="$t('common.verificationcode')"
                      name="captchaCode"
                      type="text"
                      tabindex="7"
                      autocomplete="on"
                    >
                      <template
                        v-if="props.siteId !== siteEnum.LK6"
                        #append
                      >
                        <img :src="verificationImg" @click="getCode()">
                      </template>
                      <template v-else #suffix>
                        <img :src="verificationImg" @click="getCode()">
                      </template>
                      <template v-if="props.siteId === siteEnum.LK6" #prefix>
                        <div class="prefix-wrapper">
                          <img src="../../assets/images/lk6/email-icon.png">
                          <span>{{ $t('common.verificationcode') }}</span>
                        </div>
                        <img
                          class="prefix-icon"
                          src="../../assets/images/lk6/captcha-icon-mobile.png"
                        >
                      </template>
                    </el-input>
                  </el-form-item>

                  <div class="flex-c-center-div reg-btn-grp">
                    <el-button
                      class="common-btn"
                      :loading="loading"
                      type="danger"
                      style="width:50%;"
                      @click.prevent="handleRegister"
                    >
                      {{
                        props.siteId === siteEnum.VNM || props.siteId === 8
                          ? $t('google.next_step')
                          : $t('common.apply')
                      }}
                    </el-button>
                    <el-button
                      class="common-btn default-btn"
                      style="width:50%;"
                      @click="isReg = !isReg"
                    >
                      {{ $t('common.back_login') }}
                    </el-button>
                  </div>
                  <div
                    v-if="
                      props.siteId !== siteEnum.IND &&
                        props.siteId !== siteEnum.VNM &&
                        props.siteId !== siteEnum.BR2 &&
                        props.siteId !== siteEnum.AK2 &&
                        props.siteId !== siteEnum.LK6
                    "
                    class="flex-c-center-div"
                  >
                    <div
                      class="contact-div"
                      @click="
                        props.siteId === siteEnum.PH2
                          ? openLiveChatWidget()
                          : swipeToContactUs()
                      "
                    >
                      {{ $t('common.contact_us') }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    step === 2 &&
                      (props.siteId === siteEnum.VNM ||
                        props.siteId === siteEnum.KAKA)
                  "
                >
                  <el-form-item prop="realName">
                    <el-input
                      ref="realNameRef"
                      v-model="regForm.realName"
                      :placeholder="$t('fields.realName')"
                      name="realName"
                      type="text"
                      tabindex="4"
                      autocomplete="on"
                    />
                  </el-form-item>
                  <el-form-item prop="telephone">
                    <el-input
                      ref="telephoneRef"
                      v-model="regForm.telephone"
                      :placeholder="$t('fields.telephone')"
                      name="telephone"
                      type="text"
                      tabindex="4"
                      autocomplete="on"
                    />
                  </el-form-item>
                  <el-form-item prop="email">
                    <el-input
                      ref="emailRef"
                      v-model="regForm.email"
                      :placeholder="$t('fields.email')"
                      name="Email"
                      type="text"
                      tabindex="5"
                      autocomplete="on"
                    />
                  </el-form-item>
                  <!-- <el-form-item prop="birthday">
                        <el-date-picker
                            v-model="regForm.birthday"
                            type="date"
                            :placeholder="'生日'"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            popper-class="custom-date-picker"
                            :disabled-date="disabledDate"
                        />
                  </el-form-item-->
                  <!-- <el-form-item prop="codeAffiliate" v-if="!hasAffiliate">
                  <el-input v-if="hasAffiliate"
                              ref="codeAffiliateRef"
                              v-model="regForm.codeAffiliate"
                              :placeholder="'代理码'"
                              name="codeAffiliate"
                              type="text"
                              tabindex="8"
                              autocomplete="on"
                              :disabled="true"
                  />
                  <el-input
                      ref="codeAffiliateRef"
                      v-model="regForm.codeAffiliate"
                      :placeholder="'代理码'"
                      name="codeAffiliate"
                      type="text"
                      tabindex="8"
                      autocomplete="on"
                  />
                  </el-form-item> -->
                  <!-- <el-button
                    class="common-btn"
                    :loading="loading"
                    type="danger"
                    style="width:100%;"
                    @click.prevent="handleRegister"
                  >
                    申请
                  </el-button> -->
                  <div class="flex-c-center-div">
                    <el-button
                      class="common-btn default-btn"
                      style="width:50%;"
                      @click="step = 1"
                    >
                      {{ $t('google.prev_step') }}
                    </el-button>
                    <el-button
                      class="common-btn"
                      :loading="loading"
                      type="danger"
                      style="width:50%;"
                      @click.prevent="handleRegister"
                    >
                      {{ $t('common.apply') }}
                    </el-button>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="bot">&nbsp;</div>
          </div>
          <template v-if="isLk6MobileView">
            <div v-if="!isReg" class="flex-c-center-div bottom-btn-grp">
              <el-button
                class="common-btn"
                type="danger"
                @click.prevent="handleLogin"
              >
                {{ $t('common.loginnow') }}
              </el-button>
              <el-button
                class="common-btn default-btn"
                type="primary"
                @click="isReg = !isReg"
                v-if="props.siteId !== siteEnum.BR2 && props.siteId !== siteEnum.AK2"
              >
                {{ $t('common.register_affi') }}
              </el-button>
            </div>
            <div v-else class="flex-c-center-div bottom-btn-grp">
              <el-button
                class="common-btn"
                :loading="loading"
                type="danger"
                style="width:50%;"
                @click.prevent="handleRegister"
              >
                {{
                  props.siteId === siteEnum.VNM || props.siteId === 8
                    ? $t('google.next_step')
                    : $t('common.apply')
                }}
              </el-button>
              <el-button
                class="common-btn default-btn"
                style="width:50%;"
                @click="isReg = !isReg"
              >
                {{ $t('common.back_login') }}
              </el-button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <template v-if="props.siteId === siteEnum.PH2">
    <LiveChatWidget
      :license="ph2LivechatLicenseId"
      :visibility="liveChatVisibility"
      @ready="onLiveChatReady"
      @visibility-changed="onLiveChatVisibilityChanged"
    />
    <div class="ph2-cs-entry" @click="openLiveChatWidget">
      <i class="el-icon-service" />
      <span>{{ $t('fields.onlineCustomerService') }}</span>
    </div>
    <!-- Replaced by the LiveChatWidget popup above; kept for reference.
    <el-dialog
      v-model="showCustomerService"
      :title="$t('fields.onlineCustomerService')"
      width="420px"
    >
      <p class="ph2-cs-tip">{{ $t('fields.onlineCustomerServiceTip') }}</p>
      <div v-for="item in ph2Contacts" :key="item.type" class="ph2-cs-item">
        <div class="ph2-cs-info">
          <div class="ph2-cs-type">{{ item.type }}</div>
          <div class="ph2-cs-account">{{ item.account }}</div>
        </div>
        <div>
          <el-button size="small" @click="copyContact(item.account)">
            {{ $t('common.copy') }}
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="openContact(item.url)"
          >
            {{ $t('common.contact_us') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    -->
  </template>
  <el-dialog
    v-model="showDialog"
    custom-class="dialog400"
    @close="onCloseDialog"
  >
    <template #title>
      <span class="verification-title" v-if="isClick">
        {{ $t('common.verification_title') }}
      </span>
      <span style="font-weight: bold;" v-if="isClick">
        {{ words.join(' , ') }}
      </span>
      <span class="verification-title" v-if="!isClick">
        {{ $t('common.verification_drag_title') }}
      </span>
    </template>
    <div id="loadDiv" v-loading="dialogLoading">
      <el-image
        style="cursor: pointer"
        id="imageRef"
        fit="contain"
        :src="img"
        @click="onClickImage"
        v-if="isClick"
      />
      <div class="overlapParent" v-if="!isClick">
        <el-image id="imageRef" fit="contain" :src="img" />
        <el-image id="puzzleRef" fit="contain" :src="puzzle" />
      </div>
      <div
        :style="{
          width: imageOffSetWidth + 'px',
          height: imageOffSetHeight + 'px',
          position: 'absolute',
          'z-index': '3000',
          display: resultDisplay,
          'justify-content': 'center',
          'align-items': 'center',
        }"
      >
        <i
          class="el-icon-success"
          :style="{
            'font-size': imageOffSetHeight / 2 + 'px',
            color: 'rgb(130, 208, 130)',
          }"
        />
        <span
          :style="{
            'font-size': imageOffSetHeight / 3 + 'px',
            color: 'rgb(130, 208, 130)',
          }"
        >
          {{ $t('common.verify_success') }}
        </span>
      </div>
    </div>
    <div>
      <el-button
        type="info"
        icon="el-icon-refresh"
        style="margin-top: 20px;"
        @click="onGetImage()"
        v-if="isClick"
      >
        {{ $t('common.refresh') }}
      </el-button>
      <el-button
        type="success"
        icon="el-icon-check"
        style="margin-top: 20px;"
        @click="userLogin()"
        :disabled="coordinates.length === 0"
        v-if="isClick"
      >
        {{ $t('common.submit') }}
      </el-button>
      <el-input
        id="dragInput"
        type="range"
        min="0"
        max="100"
        v-model="dragCoordinate"
        style="margin-top: 10px"
        @input="onDrag()"
        @change="onDragRelease()"
        v-if="!isClick"
      />
    </div>
  </el-dialog>
  <div v-for="(point, index) in coordinates" :key="index">
    <div
      class="image-number-point"
      :style="{left: point.displayLeft + 'px', top: point.displayTop + 'px'}"
      @click="onClickNumber(index)"
    >
      {{ index + 1 }}
    </div>
  </div>
  <el-dialog v-model="showPasswordDialog" :title="t('fields.forgetPassword')">
    <el-steps :active="passwordStep" align-center>
      <el-step :title="t('forgetPassword.verifyAuth')" />
      <el-step :title="t('forgetPassword.verifyQues')" v-if="props.siteId !== siteEnum.PH2" />
      <el-step :title="t('forgetPassword.resetPassword')" />
    </el-steps>
    <div class="auth-container" v-if="passwordStep === 1">
      <div class="auth-title">{{ $t('forgetPassword.messageAuth') }}</div>
      <el-form
        ref="googleAuthFormRef"
        :model="googleAuthForm"
        :rules="googleAuthRules"
        class="login-form"
        autocomplete="no-fill"
        label-width="100px"
      >
        <el-form-item prop="loginName" :label="t('fields.loginName')">
          <el-input
            v-model="googleAuthForm.loginName"
            :placeholder="t('fields.loginName')"
            name="loginName"
            type="text"
            autocomplete="no-fill"
          />
        </el-form-item>
        <el-form-item prop="code" :label="t('google.auth_code')">
          <el-input
            v-model="googleAuthForm.code"
            :placeholder="t('google.auth_code')"
            name="code"
            maxlength="6"
            @keypress="restrictIntegerInput($event)"
          />
        </el-form-item>
        <div class="flex-c-center-div">
          <el-button
            class="common-btn"
            type="danger"
            @click="submitVerifyGoogle"
          >
            {{ $t('forgetPassword.verify') }}
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="auth-container" v-if="passwordStep === 2">
      <el-form
        ref="quesAuthFormRef"
        :model="quesAuthForm"
        :rules="quesAuthRules"
        class="login-form"
        autocomplete="no-fill"
        label-position="top"
      >
        <div class="auth-title">{{ $t('forgetPassword.messageQues') }}</div>
        <div>
          <span>
            {{ securityQuestion.question[securityQuestion.currentIndex] }}
          </span>
          <el-link
            icon="el-icon-refresh"
            :underline="false"
            style="margin:20px"
            @click="nextQuestion()"
          />
        </div>
        <el-form-item prop="answer">
          <el-input
            v-model="quesAuthForm.answer"
            :placeholder="t('forgetPassword.answer')"
            name="answer"
            type="text"
            autocomplete="no-fill"
          />
        </el-form-item>
        <div class="flex-c-center-div">
          <el-button class="common-btn" type="danger" @click="submitVerifyQues">
            {{ $t('forgetPassword.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="auth-container" v-if="passwordStep === 3">
      <el-form
        ref="resetFormRef"
        :model="resetForm"
        :rules="resetRules"
        class="login-form"
        autocomplete="no-fill"
        label-width="100px"
      >
        <div class="auth-title">{{ $t('forgetPassword.messageReset') }}</div>
        <el-form-item prop="password" :label="t('fields.newPassword')">
          <el-input
            v-model="resetForm.password"
            :placeholder="t('fields.newPassword')"
            name="password"
            :type="passwordType"
            tabindex="2"
            autocomplete="on"
            @keyup="checkCapslock"
            @blur="capsTooltip = false"
          />
        </el-form-item>
        <el-form-item
          prop="confirmPassword"
          :label="t('fields.confirmNewPassword')"
        >
          <el-input
            v-model="resetForm.confirmPassword"
            :placeholder="t('fields.confirmNewPassword')"
            name="confirmPassword"
            :type="passwordType"
            tabindex="2"
            autocomplete="on"
            @keyup="checkCapslock"
            @blur="capsTooltip = false"
          />
        </el-form-item>
        <div class="flex-c-center-div">
          <el-button
            class="common-btn"
            type="danger"
            @click="submitResetPassword"
          >
            {{ $t('forgetPassword.reset') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
/* eslint-disable */
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs,
  computed,
  onUnmounted,
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { storeToRefs } from 'pinia';
import { UserActionTypes } from '@/store/modules/user/action-types'
import { ElNotification, ElMessage } from 'element-plus'
import dyLogo from '@/assets/images/dy/logowhitee.png'
import xfLogo from '@/assets/images/xf/logowhitee.png'
import indLogo from '@/assets/images/ind/ind-logo.png'
import ind2Logo from '@/assets/images/ind2/789logo.png'
import lhLogo from '@/assets/images/lh/logo.png'
import viLogo from '@/assets/images/vi/vilogo.svg'
import kakaLogo from '@/assets/images/kaka/logo-kaka-game.png'
import krLogo from '@/assets/images/kr/kr-logo.png'
import pakLogo from '@/assets/images/pak/logowhitee.png'
import ph2Logo from '@/assets/images/ph2/ph2-logo.png'
import br2Logo from '@/assets/images/br2/br2-logo.png'
import ak2Logo from '@/assets/images/ak2/ak2-logo.png'
import lk6Logo from '@/assets/images/lk6/lk6-logo.png'
import mx4Logo from '@/assets/images/mx4/logo.svg'
import { getVerificationImage } from '@/api/verification'
import {
  getVerificationCode,
  verifyGoogleAuthentication,
  getSecurityQuestionsList,
  verifySecurityQuestions,
  resetLoginPassword,
} from '@/api/user'
import { useI18n } from 'vue-i18n'
import { i18nStore } from '@/store/language'
import LhFeedback from '../customer-service/lh-feedback.vue'
import LangToggle from '../lang/LangToggle.vue'
import { siteEnum } from '@/consts/SiteEnum'
import { getDevice } from "@/utils/util";
import { getConfigByCode } from '@/api/config';
import { LiveChatWidget } from '@livechat/widget-vue'

export default defineComponent({
  props: {
    siteId: {
      type: [String, Number], // Specify the allowed types for the prop
      required: true,
    },
  },
  components: {
    LhFeedback,
    LangToggle,
    LiveChatWidget,
  },
  setup(props) {
    const validatePass2 = async (r, v) => {
      if (v === '') {
        return Promise.reject(new Error(t('message.required_confirm_pwd')))
      } else if (v !== state.regForm.password) {
        return Promise.reject(
          new Error(t('message.required_same_with_password'))
        )
      } else {
        return Promise.resolve()
      }
    }
    const validateResetPass2 = async (r, v) => {
      if (v === '') {
        return Promise.reject(new Error(t('message.required_confirm_pwd')))
      } else if (v !== state.resetForm.password) {
        return Promise.reject(
          new Error(t('message.required_same_with_password'))
        )
      } else {
        return Promise.resolve()
      }
    }
    const validateRealName = async (r, v) => {
      if (v === '') {
        return Promise.reject(new Error(t('message.requiredRealName')))
      } else if (
        !checkRealName(v) &&
        props.siteId !== siteEnum.VNM &&
        props.siteId !== siteEnum.KAKA
      ) {
        return Promise.reject(new Error('请输入中文字符'))
      } else {
        return Promise.resolve()
      }
    }

    const checkRealName = v => {
      // const alphanumeric = /^[\p{L}\p{N}]*$/u;
      const chineseCharOnly = /^([\u4e00-\u9fa5]*)$/u
      return v.match(chineseCharOnly)
    }
    const getCode = () => {
      getVerificationCode()
        .then(res => {
          if (res.code === 0) {
            // Data Image
            verificationImg.value = 'data:image/png;base64,' + res.data.img
            state.regForm.codeId = res.data.id
            state.loginForm.codeId = res.data.id
          }
        })
        .catch(e => {})
    }
    const isReg = ref(false)
    const userNameRef = ref(null)
    const passwordRef = ref(null)
    const loginFormRef = ref(null)
    const regFormRef = ref(null)
    const verificationImg = ref('')
    const confirmPwdRef = ref(null)
    const realNameRef = ref(null)
    const telephoneRef = ref(null)
    const emailRef = ref(null)
    const birthdayRef = ref(null)
    const verificationRef = ref(null)
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const { t } = useI18n()
    const hasAffiliate = ref(false)
    const step = ref(1)
    const passwordStep = ref(1)
    const googleAuthFormRef = ref(null)
    const quesAuthFormRef = ref(null)
    const resetFormRef = ref(null)
    const captchaImg = ref('')
    const isClick = ref(1)
    const dragCoordinate = ref(0)
    const isMobileView = ref(false)
    const regDevice = getDevice() === "MOBILE" ? "H5" : "WEB";
    const isLoading = ref(false);
    let isCaptchaComponentUnmounted = false;
    let captchaInstance = null;
    const state = reactive({
      loginForm: {
        userName: '',
        password: '',
        site: 'DY2',
        key: '',
        coordinates: '',
        captchaCode: '',
        codeId: '',
      },
      regForm: {
        userName: '',
        password: '',
        confirmPwd: '',
        realName: '',
        telephone: '',
        email: '',
        captchaCode: '',
        regHost: location.hostname,
        codeId: '',
        codeAffiliate: '',
      },
      regRules: {
        userName: [
          {
            required: true,
            message: t('message.required_signup_account'),
            trigger: 'blur',
          },
          {
            min: 6,
            max: 12,
            message: t('message.required_6_to_12'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: t('message.requried_password'),
            trigger: 'blur',
          },
          {
            min: 6,
            max: 12,
            message: t('message.required_6_to_12'),
            trigger: 'blur',
          },
        ],
        confirmPwd: [
          {
            required: true,
            message: t('message.required_confirm_pwd'),
            trigger: 'blur',
          },
          {
            validator: validatePass2,
            trigger: 'blur',
          },
        ],
        realName: [
          {
            validator: validateRealName,
            trigger: 'blur',
          },
        ],
        telephone: [
          {
            required: true,
            message: t('message.requiredTelephone'),
            trigger: 'blur',
          },
        ],
        birthday: [
          {
            required: true,
            message: '生日不能为空',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: t('message.requiredEmail'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: t('message.emailFormat'),
            trigger: 'blur',
          },
          {
            max: 50,
            message: t('message.lessthan50'),
            trigger: 'blur',
          },
        ],
        captchaCode: [
          {
            required: true,
            message: t('message.required_captcha'),
            trigger: 'blur',
          },
          {
            min: 4,
            max: 4,
            message: t('message.required_4_digits'),
            trigger: 'change',
          },
        ],
      },
      googleAuthForm: {
        loginName: '',
        code: '',
      },
      googleAuthRules: {
        loginName: [
          {
            required: true,
            message: t('message.requiredLoginName'),
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^[a-zA-Z1-9][a-zA-Z0-9]*$/,
            message: '代理账号只能有数字或字母组成',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: t('google.google_auth_code'),
            trigger: 'blur',
          },
        ],
      },
      quesAuthForm: {
        answer: '',
        questionNumber: '',
      },
      quesAuthRules: {
        answer: [
          {
            required: true,
            message: t('message.requiredAnswer'),
            trigger: 'blur',
          },
        ],
      },
      resetForm: {
        password: '',
        confirmPassword: '',
      },
      resetRules: {
        password: [
          {
            required: true,
            message: '登录密码不能为空',
            trigger: 'blur',
          },
          {
            min: 6,
            max: 12,
            message: '由6-12位数字或字母组成',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            validator: validateResetPass2,
            trigger: 'blur',
          },
        ],
      },
      passwordType: 'password',
      showDialog: false,
      capsTooltip: false,
      redirect: '',
      otherQuery: {},
      words: [],
      codeId: '',
      img: '',
      coordinates: [],
      dialogLoading: false,
      imageOffSetWidth: 200,
      imageOffSetHeight: 100,
      resultDisplay: 'none',
      showPasswordDialog: false,
      securityQuestion: {
        question: [],
        currentIndex: 0,
      },
      twoFaCode: '',
      puzzle: '',
      puzzleXvalue: '',
    })

    const loginRules = computed(() => {
      return {
        userName: [
          {
            required: true,
            message: t('message.requiredLoginName'),
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^[a-zA-Z0-9_][a-zA-Z0-9_]*$/,
            message: t('common.affiliateaccountcanonlycontainnumchar'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: t('message.requiredPassword'),
            trigger: 'blur',
          },
        ],
      }
    })

    const loginRulesVi = computed(() => {
      return {
        userName: [
          {
            required: true,
            message: t('message.requiredLoginName'),
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^[a-zA-Z1-9][a-zA-Z0-9]*$/,
            message: t('common.affiliateaccountcanonlycontainnumchar'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: t('message.requiredPassword'),
            trigger: 'blur',
          },
        ],
        captchaCode: [
          {
            required: true,
            message: t('message.required_captcha'),
            trigger: 'blur',
          },
          {
            min: 4,
            max: 4,
            message: t('message.required_4_digits'),
            trigger: 'change',
          },
        ],
      }
    })

    function disabledDate(time) {
      return time.getTime() > new Date().getTime()
    }
    const methods = reactive({
      validatePasswordLength: (rule, value, callback) => {
        if (value.length < 6 || value.length > 12) {
          callback(new Error('密码长度为6-12'))
        } else {
          callback()
        }
      },
      checkCapslock: e => {
        const { key } = e
        if (key) {
          state.capsTooltip =
            key !== null && key.length === 1 && key >= 'A' && key <= 'Z'
        }
      },
      showPwd: () => {
        if (state.passwordType === 'password') {
          state.passwordType = ''
        } else {
          state.passwordType = 'password'
        }
        nextTick(() => {
          passwordRef.value.focus()
        })
      },
      handleLogin: () => {
        loginFormRef.value.validate(async valid => {
          if (valid) {
            if (
              state.loginForm.site === 'IND' ||
              state.loginForm.site === 'IW2' ||
              state.loginForm.site === 'VNM' ||
              state.loginForm.site === 'BR2' ||
              state.loginForm.site === 'BR1' ||
              state.loginForm.site === 'KRW' ||
              state.loginForm.site === 'PH2' ||
              state.loginForm.site === 'AK2' ||
              state.loginForm.site === 'MX4' ||
              state.loginForm.site === 'XF1' ||
              state.loginForm.site === 'DY2' ||
              state.loginForm.site === 'LH1'
            ) {
              methods.userLogin()
            } else {
              methods.onGetImage()
              state.showDialog = true
            }
          }
        })
      },
      handleRegister: () => {
        state.regForm.siteId = props.siteId
        regFormRef.value.validate(async valid => {
          if (valid) {
            if (
              props.siteId === siteEnum.KAKA ||
              props.siteId === 15 ||
              props.siteId === siteEnum.VNM ||
              props.siteId === 8
            ) {
              if (step.value === 1) {
                step.value = 2
                return
              }
            }
            state.loading = true
            try {
              await store.dispatch(
                UserActionTypes.ACTION_REGISTER,
                state.regForm
              )
              if (props.siteId === siteEnum.PH2) {
                ElNotification({
                  title: t('fields.systemAlert'),
                  message: t('fields.affiliateSuccessSubmitPh2').replace(
                    /\n/g,
                    '<br>'
                  ),
                  dangerouslyUseHTMLString: true,
                  duration: 15000,
                  showClose: true,
                  type: 'success',
                })
                openLiveChatWidget()
              } else {
                ElNotification({
                  title: t('fields.systemAlert'),
                  message: t('fields.affiliateSuccessSubmit'),
                  showClose: false,
                  type: 'success',
                })
              }
            } catch (e) {
              ElNotification({
                title: t('fields.systemAlert'),
                message: e.message,
                showClose: false,
                type: 'error',
              })
              step.value = 1
              getCode()
              state.loading = false
              return
            }
            // router.push({
            //   path: state.redirect || "/dy/login",
            //   query: state.otherQuery
            // }).catch(err => {
            //   console.warn(err);
            // });
            isReg.value = false
          }
        })
      },
      onFail: () => {
        const elDialog = document.getElementsByClassName('el-dialog')[0]
        elDialog.classList.add('shake')
        setTimeout(() => {
          elDialog.classList.remove('shake')
        }, 500)
        methods.onGetImage()
        if (state.loginForm.site === 'KA2') {
          getCaptcha()
        }
        state.coordinates.splice(0)
      },
      onSuccess: async () => {
        if (
          state.loginForm.site === 'IND' ||
          state.loginForm.site === 'IW2' ||
          state.loginForm.site === 'VNM' ||
          state.loginForm.site === 'KA2' ||
          state.loginForm.site === 'PH2' ||
          state.loginForm.site === 'KRW' ||
          state.loginForm.site === 'XF1' ||
          state.loginForm.site === 'DY2' ||
          state.loginForm.site === 'LH1'
        ) {
          router
            .push({
              path: state.redirect || '/',
              query: state.otherQuery,
            })
            .catch(err => {
              console.warn(err)
            })
        } else if (
          state.loginForm.site === 'BR2' ||
          state.loginForm.site === 'BR1' ||
          state.loginForm.site === 'AK2' ||
          state.loginForm.site === 'MX4'
        ) {
          router
            .push({
              path: state.redirect || '/report/daily-detail',
              query: state.otherQuery,
            })
            .catch(err => {
              console.warn(err)
            })
        } else {
          state.resultDisplay = 'flex'
          var image = document.getElementById('imageRef')
          state.imageOffSetWidth = image.offsetWidth
          state.imageOffSetHeight = image.offsetHeight
          state.dialogLoading = false
          image.style.opacity = '0.1'
          setTimeout(() => {
            router
              .push({
                path: state.redirect || '/',
                query: state.otherQuery,
              })
              .catch(err => {
                console.warn(err)
              })
          }, 500)
        }
      },
      onClickImage: e => {
        if (state.coordinates.length < 5) {
          var image = document.getElementById('imageRef')
          var x = e.clientX - image.getBoundingClientRect().x
          var y = e.clientY - image.getBoundingClientRect().y
          var storeX = x
          var storeY = y
          if (image.getBoundingClientRect().x !== 200) {
            storeX = (x / image.offsetWidth) * 200
            storeY = (y / image.offsetHeight) * 100
          }
          state.coordinates.push({
            displayLeft: e.pageX - 12,
            displayTop: e.pageY - 12,
            left: e.pageX - image.getBoundingClientRect().x,
            top: e.pageY - image.getBoundingClientRect().y,
            x: storeX,
            y: storeY,
          })
        }
      },
      onClickNumber: index => {
        state.coordinates.splice(index)
      },
      onCloseDialog: () => {
        state.coordinates.splice(0)
      },
      onScrollEvent: () => {
        if (state.showDialog) {
          var image = document.getElementById('imageRef')
          state.imageOffSetWidth = image.offsetWidth
          state.imageOffSetHeight = image.offsetHeight
          var imageX = image.getBoundingClientRect().x
          var imageY = image.getBoundingClientRect().y
          for (var i in state.coordinates) {
            state.coordinates[i].displayLeft =
              imageX + state.coordinates[i].left - 12
            state.coordinates[i].displayTop =
              imageY + state.coordinates[i].top - 12
          }
        }
      },
      userLogin: async () => {
        state.dialogLoading = true
        state.loginForm.key = state.codeId
        if (isClick.value === 1) {
          const coordinatesString = []
          for (let i = 0; i < state.coordinates.length; i++) {
            const obj = []
            obj.push(state.coordinates[i].x)
            obj.push(state.coordinates[i].y)
            coordinatesString.push(obj.join(','))
            state.loginForm.coordinates = coordinatesString.join('-')
          }
          state.coordinates.splice(0)
        }
        if (state.loginForm.site === 'XF1' || state.loginForm.site === 'DY2' || state.loginForm.site === 'LH1') {
          isLoading.value = true;
          if (window.captchaObj) {
            const validate = window.captchaObj.getValidate();
            if (!validate) {
              ElMessage.error({
                type: 'error',
                message: "请完成验证码"
              })
              return;
            }
          }
          isLoading.value = false;
        }

        try {
          await store.dispatch(UserActionTypes.ACTION_LOGIN, state.loginForm)
        } catch (e) {
          if (e.message === '验证失败') {
            methods.onFail()
          } else if (
            state.loginForm.site === 'VNM' ||
            state.loginForm.site === 'KA2'
          ) {
            methods.onFail()
          } else if (
            state.loginForm.site === 'XF1' ||
            state.loginForm.site === 'DY2' ||
            state.loginForm.site === 'LH1'
          ) {
            window.captchaObj.reset();
          } else {
            state.showDialog = false
          }
          state.dialogLoading = false
          return
        }
        if (props.siteId === siteEnum.PH2) {
          // lets ph2-affiliate-popup know this session was just logged in via the PH2 login page
          sessionStorage.setItem('ph2AffiliatePopupPending', '1')
        }
        methods.onSuccess()
      },
      onGetImage: async () => {
        state.dialogLoading = true
        state.coordinates.splice(0)
        const imgType =
          languageVal === 'vi' ||
          languageVal === 'en' ||
          languageVal === 'kr' ||
          state.loginForm.site === 'VNM' ||
          state.loginForm.site === 'KA2'
            ? 1
            : 0
        dragCoordinate.value = 0
        if (
          state.loginForm.site === 'XF1' ||
          state.loginForm.site === 'DY2' ||
          state.loginForm.site === 'LH1'
        ) {
          isClick.value = 0
        }
        const { data } = await getVerificationImage(imgType, isClick.value)
        Object.keys({ ...data.data }).forEach(field => {
          state[field] = data.data[field]
        })
        state.dialogLoading = false
      },
      forgetPasswordDialog: () => {
        passwordStep.value = 1
        state.googleAuthForm.loginName = ''
        state.googleAuthForm.code = ''
        state.quesAuthForm.answer = ''
        state.quesAuthForm.questionNumber = ''
        state.resetForm.password = ''
        state.resetForm.confirmPassword = ''
        state.showPasswordDialog = true
      },
      restrictIntegerInput: event => {
        var charCode = event.which ? event.which : event.keyCode
        if (charCode < 48 || charCode > 57 || charCode === 46) {
          event.preventDefault()
        }
      },
      submitVerifyGoogle: () => {
        googleAuthFormRef.value.validate(async valid => {
          if (valid) {
            const { data: ret } = await verifyGoogleAuthentication(
              state.googleAuthForm.loginName,
              props.siteId,
              state.googleAuthForm.code
            )
            if (props.siteId === siteEnum.PH2) {
              passwordStep.value = 3
            } else {
              const { data: ret1 } = await getSecurityQuestionsList(
                state.googleAuthForm.loginName,
                props.siteId
              )
              state.twoFaCode = ret
              if (ret1 === null || ret1 === undefined) {
                ElMessage.error(t('forgetPassword.noSecurityQuestionSet'))
              }
              state.securityQuestion.question.push(ret1.questionOne)
              state.securityQuestion.question.push(ret1.questionTwo)
              state.securityQuestion.question.push(ret1.questionThree)
              passwordStep.value = 2
            }
          }
        })
      },
      nextQuestion: () => {
        state.securityQuestion.currentIndex =
          state.securityQuestion.currentIndex === 2
            ? 0
            : state.securityQuestion.currentIndex + 1
      },
      submitVerifyQues: () => {
        quesAuthFormRef.value.validate(async valid => {
          if (valid) {
            const { data: ret } = await verifySecurityQuestions(
              state.googleAuthForm.loginName,
              props.siteId,
              state.quesAuthForm.answer,
              state.securityQuestion.currentIndex + 1,
              state.twoFaCode
            )
            state.twoFaCode = ret
            passwordStep.value = 3
          }
        })
      },
      submitResetPassword: () => {
        resetFormRef.value.validate(async valid => {
          if (valid) {
            await resetLoginPassword(
              state.googleAuthForm.loginName,
              props.siteId,
              state.resetForm.password,
              state.twoFaCode
            )
            ElMessage.success(t('forgetPassword.resetSuccess'))
            state.showPasswordDialog = false
          }
        })
      },
      onDrag: () => {
        var image = document.getElementById('imageRef')
        var puzzle = document.getElementById('puzzleRef')
        puzzle.style.marginLeft =
          (dragCoordinate.value / 100) * image.offsetWidth + 'px'
      },
      onDragRelease: () => {
        state.loginForm.coordinates = (dragCoordinate.value / 100) * 200
        methods.userLogin()
      },
    })

    const handleResize = () => {
      // Handle the resize event here
      if (window.innerWidth > 768) {
        // Do something when the window is wider than 768
        isMobileView.value = false
      } else {
        isMobileView.value = true
      }
    }

    function getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }

    watch(
      () => route.query,
      query => {
        if (query) {
          state.redirect = query.redirect?.toString() ?? ''
          state.otherQuery = getOtherQuery(query)
        }
      },
      () => isReg.value,
      newIsReg => {
        if (newIsReg) {
          if (route.query.agent) {
            hasAffiliate.value = true
            state.regForm.codeAffiliate = route.query.agent
          } else {
            hasAffiliate.value = false
          }
          getCode()
          // if (state.regForm.userName === '') {
          //   userNameRef.value.focus()
          // } else if (state.regForm.password === '') {
          //   passwordRef.value.focus()
          // }
        }
      }
    )

    watch(
      () => isReg.value,
      newIsReg => {
        if (
          !newIsReg &&
          window.captchaObj &&
          (props.siteId === siteEnum.XF1 ||
            props.siteId === siteEnum.DY2 ||
            props.siteId === siteEnum.LH1)
        ) {
          nextTick(() => {
            const captchaContainer = document.getElementById('captchaContainer')
            if (captchaContainer) {
              captchaContainer.innerHTML = ''
              window.captchaObj.appendTo('#captchaContainer')
            }
          })
        }
      }
    )

    // const ph2Contacts = [
    //   {
    //     type: 'WhatsApp',
    //     account: 'B9GAME88',
    //     url: 'https://wa.me/qr/LLQUOQXVCWE5D1',
    //   },
    //   {
    //     type: 'Telegram',
    //     account: 'B9GAME88',
    //     url: 'https://t.me/B9GAME88',
    //   },
    //   {
    //     type: 'Email',
    //     account: 'b9gameph@gmail.com',
    //     url: 'mailto:b9gameph@gmail.com',
    //   },
    // ]
    // const openContact = url => {
    //   window.open(url, '_blank', 'noopener')
    // }
    // const copyContact = async text => {
    //   try {
    //     await navigator.clipboard.writeText(text)
    //     ElMessage.success(t('common.copy'))
    //   } catch (e) {
    //     ElMessage.error(text)
    //   }
    // }

    // PH2 online customer service LiveChat widget (same widget as ph2-static-v1's HomePage)
    const ph2LivechatLicenseId = '19347541'
    const liveChatVisibility = ref('hidden')
    const isLiveChatReady = ref(false)
    const isLiveChatPendingOpen = ref(false)
    const openLiveChatWidget = () => {
      if (!isLiveChatReady.value) {
        isLiveChatPendingOpen.value = true
        return
      }
      liveChatVisibility.value = 'maximized'
    }
    const onLiveChatReady = () => {
      isLiveChatReady.value = true
      if (isLiveChatPendingOpen.value) {
        isLiveChatPendingOpen.value = false
        liveChatVisibility.value = 'maximized'
      }
    }
    const onLiveChatVisibilityChanged = data => {
      liveChatVisibility.value = data.visibility === 'maximized' ? 'maximized' : 'hidden'
    }

    const swipeToContactUs = () => {
      const windowWidth = window.innerWidth
      const isMobile = windowWidth < 768
      const isCitySite = props.siteId === siteEnum.KRW
      const contactUrl = 'https://t.me/city88888'

      if (isMobile) {
        if (!isCitySite) {
          const customerServiceElement = document.getElementById(
            'div-customer-service'
          )
          window.scrollTo({
            top: customerServiceElement.offsetTop,
            behavior: 'smooth',
          })
        } else {
          window.open(contactUrl, '_blank').focus()
        }
      } else {
        if (!isCitySite) {
          const loginSwiperElement = document.getElementById('login-swiper')
          loginSwiperElement.swiper.slideTo(1)
        } else {
          window.open(contactUrl, '_blank').focus()
        }
      }
    }

    const getCaptcha = () => {
      state.loginForm.captchaCode = ''

      getVerificationCode().then(res => {
        if (res.code === 0) {
          captchaImg.value = 'data:image/png;base64,' + res.data.img
          state.loginForm.codeId = res.data.id
        } else {
          ElMessage.error({
            type: 'error',
            message: res.message,
          })
        }
      })
    }

    const currentSite = ref({})
    const i18nStoreLanguage = i18nStore()
    const { setLanguage } = i18nStoreLanguage;
    const { languageVal } = storeToRefs(i18nStoreLanguage);

    const populateCurrentSiteData = () => {
      if (props.siteId === siteEnum.DY2) {
        currentSite.value.firstLiner = '从东赢开始'
        currentSite.value.secondLiner = '成为传奇<br>还是成为传奇的歌颂者'
        currentSite.value.logo = dyLogo
        state.loginForm.site = 'DY2'
        setLanguage('zh')
      }
      if (props.siteId === siteEnum.XF1) {
        currentSite.value.firstLiner = '从兴发开始'
        currentSite.value.secondLiner = '成为传奇<br>还是成为传奇的歌颂者'
        currentSite.value.logo = xfLogo
        state.loginForm.site = 'XF1'
        setLanguage('zh')
      }
      if (props.siteId === siteEnum.IND) {
        currentSite.value.firstLiner = 'Starts from 55ACE'
        currentSite.value.secondLiner =
          'Become a legend<br>Or become the eulogist of legend?'
        currentSite.value.logo = indLogo
        state.loginForm.site = 'IND'
        currentSite.value.lang = 'EN'
        setLanguage('en')
      }
      if (props.siteId === siteEnum.AK2) {
        currentSite.value.firstLiner = 'Starts from AKB188'
        currentSite.value.secondLiner =
          'Become a legend<br>Or become the eulogist of legend?'
        currentSite.value.logo = ak2Logo
        state.loginForm.site = 'AK2'
        currentSite.value.lang = 'EN'
        setLanguage('en')
      }
      if (props.siteId === siteEnum.IW2) {
        currentSite.value.firstLiner = 'Starts from 789F'
        currentSite.value.secondLiner =
          'Become a legend<br>Or become the eulogist of legend?'
        currentSite.value.logo = ind2Logo
        state.loginForm.site = 'IW2'
        currentSite.value.lang = 'EN'
        setLanguage('en')
      }
      if (props.siteId === siteEnum.LH1) {
        // currentSite.value.firstLiner = '从雷火开始'
        // currentSite.value.secondLiner = '成为传奇<br>还是成为传奇的歌颂者'
        const firstLinerImg = require('@/assets/images/login/lh-login-2.png')
        const secondLinerImg = require('@/assets/images/login/lh-login-3.png')
        const h5BannerImg = require('@/assets/images/login/lh-banner.png')

        currentSite.value.firstLiner = `<img class="top-img lh-web-banner" src="${firstLinerImg}" style="width: 95%;"><img class="lh-h5-banner" src="${h5BannerImg}">`
        currentSite.value.secondLiner = `<img class="top-img" src="${secondLinerImg}" style="width: 95%;">`

        currentSite.value.logo = lhLogo
        state.loginForm.site = 'LH1'
        setLanguage('zh')
      }
      if (props.siteId === siteEnum.VNM) {
        currentSite.value.firstLiner = 'Start From TFGaming'
        currentSite.value.secondLiner =
          'Nơi bắt đầu mới -Chia sẻ cơ hội-Hợp tác thành công'
        currentSite.value.logo = viLogo
        state.loginForm.site = 'VNM'

        const hasPreferredLang = route?.query?.lang
        if (hasPreferredLang && ['en', 'vi'].includes(hasPreferredLang)) {
          setLanguage(hasPreferredLang)
        } else {
          setLanguage('vi')
        }
      }
      if (props.siteId === siteEnum.KAKA) {
        currentSite.value.firstLiner = 'Bắt đầu với KAKA'
        currentSite.value.secondLiner =
          'trở thành một huyền thoại<br/>Hoặc trở thành nhà điếu văn của huyền thoại?'
        currentSite.value.logo = kakaLogo
        state.loginForm.site = 'KA2'
        setLanguage('vi')
      }
      if (props.siteId === siteEnum.KRW) {
        currentSite.value.firstLiner = 'Start From CITY8'
        currentSite.value.secondLiner =
          'Become a legend<br>Or become the eulogist of legend?'
        currentSite.value.logo = krLogo
        state.loginForm.site = 'KRW'
        setLanguage('kr')
      }
      if (props.siteId === siteEnum.PAK) {
        currentSite.value.firstLiner = 'Start From B9'
        currentSite.value.secondLiner =
          'Become a legend<br>Or become the eulogist of legend?'
        currentSite.value.logo = pakLogo
        state.loginForm.site = 'PAK'
        setLanguage('zh')
      }
      if (props.siteId === siteEnum.PH2) {
        currentSite.value.firstLiner = 'Welcome sa <div class="linear">B9.Game</div>'
        currentSite.value.secondLiner =
          'Simulan ang iyong susunod na adventure.'
        currentSite.value.logo = ph2Logo
        state.loginForm.site = 'PH2'
        currentSite.value.lang = 'PH'
        setLanguage('ph')
      }
      if (props.siteId === siteEnum.BR1) {
        currentSite.value.firstLiner = 'Começa a partir de 55ACE'
        currentSite.value.secondLiner =
          'Torne-se uma lenda<br>Ou torne-se o elogista da lenda?'
        currentSite.value.logo = indLogo
        state.loginForm.site = 'BR1'
        currentSite.value.lang = 'PT'
        setLanguage('pt')
      }
      if (props.siteId === siteEnum.BR2) {
        currentSite.value.firstLiner = 'Começa a partir de AKB188'
        currentSite.value.secondLiner =
          'Torne-se uma lenda<br>Ou torne-se o elogista da lenda?'
        currentSite.value.logo = br2Logo
        state.loginForm.site = 'BR2'
        currentSite.value.lang = 'PT'
        setLanguage('pt')
      }
      if (props.siteId === siteEnum.LK6) {
        // currentSite.value.firstLiner = '终身分润 躺赚无忧'
        // currentSite.value.secondLiner = '专属运营顾问一对一服务\n让您赢在前线'
        currentSite.value.logo = lk6Logo
        state.loginForm.site = 'LK6'
        // currentSite.value.lang = 'EN'
        setLanguage('zh')
      }
      if (props.siteId === siteEnum.MX4) {
        currentSite.value.firstLiner = 'Start with Apexo'
        currentSite.value.secondLiner =
          "You'll be a legend<br>or the one who tells the tale"
        currentSite.value.logo = mx4Logo
        state.loginForm.site = 'MX4'
        setLanguage('en')
      }
    }

    watch(
      () => [props.siteId, languageVal.value],
      ([siteId, lang]) => {
        if (siteId.toString() === siteEnum.LK6) {
          if (lang === 'en') {
            const firstLinerImg = require('@/assets/images/login/lk6-login-en.png')
            currentSite.value.firstLiner = `<img class="top-img" src="${firstLinerImg}" style="width: 60%;">`
            currentSite.value.secondLiner =
              'Dedicated Operations Consultant with One-on-One Service.\nBe First to Win, First to Earn'

            const secondLinerEl = document.querySelector('.second-liner')
            if (secondLinerEl) {
              if (window.innerWidth > 768) {
                secondLinerEl.style.fontSize = '2rem'
              } else {
                secondLinerEl.style.fontSize = '1.25rem'
              }
            }
          } else {
            const firstLinerImg = require('@/assets/images/login/lk6-login-zh.png')
            currentSite.value.firstLiner = `<img class="top-img" src="${firstLinerImg}" style="width: 60%;">`
            currentSite.value.secondLiner =
              '专属运营顾问一对一服务\n让您赢在前线'

            const secondLinerEl = document.querySelector('.second-liner')
            if (secondLinerEl) {
              if (window.innerWidth > 768) {
                secondLinerEl.style.fontSize = '3.125rem'
              } else {
                secondLinerEl.style.fontSize = '1.25rem'
              }
            }
          }
        }
      },
      { immediate: true }
    )

    const isNotMobile = () => {
      const ua = navigator.userAgent
      return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        ua
      )
    }

    onMounted(async () => {
      // const swiper = new Swiper('.swiper-container', swiperOptions);
      if (route.query.agent) {
        hasAffiliate.value = true
        state.regForm.codeAffiliate = route.query.agent
      } else {
        hasAffiliate.value = false
      }
      if (route.query.isreg) {
        isReg.value = true
      }
      // if (props.siteId !== '8') {
      getCode()
      // }
      // if (state.loginForm.userName === '') {
      //   userNameRef.value.focus()
      // } else if (state.loginForm.password === '') {
      //   passwordRef.value.focus()
      // }
      var dialog = document.querySelector('.el-overlay-dialog')
      dialog.addEventListener('scroll', methods.onScrollEvent)
      window.addEventListener('resize', methods.onScrollEvent)
      window.addEventListener('resize', handleResize)
      // Check if the window width is greater than 768 initially
      if (window.innerWidth > 768) {
        isMobileView.value = false
      } else {
        isMobileView.value = true
      }
      populateCurrentSiteData()
      if (props.siteId === siteEnum.VNM) {
        getCaptcha()
      }
      if (props.siteId === siteEnum.XF1 || props.siteId === siteEnum.DY2 || props.siteId === siteEnum.LH1) {
        try {
          // Step 1: Load Geetest script
          await loadScript("/static/gt4.js");

          // Step 2: Call your backend to get Geetest configuration (fake config for demo)
          let siteCode = props.siteId === siteEnum.XF1 ? 'XF1' : (props.siteId === siteEnum.DY2 ? 'DY2' : 'LH1')
          let way = getDevice() === "MOBILE" ? "H5" : "WEB";
          let configCode = siteCode + "-" + way + "-GEETEST-ID";

          const { data } = await getConfigByCode(configCode, props.siteId);
          let captchaId = data;
          console.log(captchaId)

          const geetestConfig = {
            config: {
              captchaId: captchaId,
              language: "zho",
              nativeButton: {
                width: "100%",
                height: "48px"
              },
              nextWidth: "220px"
            },
            handler: captchaHandler
          };

          // Step 3: Initialize Geetest with the config
          await initGeetest(geetestConfig);
        } catch (error) {
          console.error("Geetest loading error:", error);
        }
      }
    })

    onUnmounted(() => {
      isCaptchaComponentUnmounted = true
      if (captchaInstance && typeof captchaInstance.destroy === 'function') {
        captchaInstance.destroy()
      }
      if (window.captchaObj === captchaInstance) {
        window.captchaObj = null
      }
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('resize', methods.onScrollEvent)
    })

    const isLk6MobileView = computed(() => {
      return props.siteId === siteEnum.LK6 && isMobileView.value
    })

    // Dynamically load the Geetest script
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    const initGeetest = (config) => {
      console.log(config);
      window.initGeetest4(config.config, config.handler);
    };

    function captchaHandler(captchaObj) {
      // Geetest initializes asynchronously. Ignore a callback from an old
      // LoginRegisterPage instance after responsive layout switching.
      if (isCaptchaComponentUnmounted) {
        if (typeof captchaObj.destroy === 'function') {
          captchaObj.destroy()
        }
        return
      }
      if (
        captchaInstance &&
        captchaInstance !== captchaObj &&
        typeof captchaInstance.destroy === 'function'
      ) {
        captchaInstance.destroy()
      }
      captchaInstance = captchaObj
      window.captchaObj = captchaObj;
      const captchaContainer = document.getElementById("captchaContainer");
      if (captchaContainer) {
        captchaContainer.innerHTML = "";
      }
      captchaObj
        .appendTo("#captchaContainer")
        .onReady(function () {
          // console.log("ready");
        })
        .onNextReady(function () {
          // console.log("nextReady");
        })
        .onBoxShow(function () {
          isLoading.value = true;
        })
        .onError(function (e) {
          console.log(e);
        })
        .onSuccess(function () {
          let result = window.captchaObj.getValidate();
          state.loginForm['lotNumber'] = result['lot_number']
          state.loginForm['captchaOutput'] = result['captcha_output']
          state.loginForm['passToken'] = result['pass_token']
          state.loginForm['genTime'] = result['gen_time']
          console.log(state.loginForm);
          isLoading.value = false;
        })
        .onClose(() => {
          isLoading.value = false;
        });
    }

    return {
      userNameRef,
      passwordRef,
      loginFormRef,
      confirmPwdRef,
      realNameRef,
      telephoneRef,
      emailRef,
      birthdayRef,
      verificationRef,
      regFormRef,
      dyLogo,
      xfLogo,
      lhLogo,
      verificationImg,
      disabledDate,
      ...toRefs(state),
      ...toRefs(methods),
      getCode,
      hasAffiliate,
      step,
      isReg,
      currentSite,
      props,
      t,
      swipeToContactUs,
      ph2LivechatLicenseId,
      liveChatVisibility,
      openLiveChatWidget,
      onLiveChatReady,
      onLiveChatVisibilityChanged,
      passwordStep,
      googleAuthFormRef,
      quesAuthFormRef,
      resetFormRef,
      getCaptcha,
      captchaImg,
      dragCoordinate,
      isClick,
      loginRules,
      loginRulesVi,
      siteEnum,
      isMobileView,
      isLk6MobileView,
      initGeetest,
      regDevice,
    }
  },
})
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}
.common-btn {
  font-family: Jura;
  transition: all 0.8s, color 0.3s 0.3s;
  min-width: 120px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: #458bff;
  border-radius: 14px;
  font-size: 14px;
  color: #ffffff;
  border: 1px solid transparent;
  opacity: 0.9;
  &:hover {
    opacity: 1;
  }

  &.default-btn {
    background-color: transparent;
    border: 1px solid #458bff;
    color: #458bff;
  }

  &:hover {
    opacity: 0.9;
  }
  &:active {
    filter: brightness(0.85);
    transform: translate(0px, 1px);
  }
}
:deep(.el-input-group__append) {
  background-color: #ffffff;
  border: 0;
  padding: 0 10px;
  border-radius: 0;
  img {
    display: flex;
  }
}
:deep(.el-input-group__prepend) {
  background-color: #2144c6;
  border: 0;
  padding: 0;
  border-radius: 0;
  i {
    display: flex;
    justify-content: center;
    img {
      height: 40px;
    }
  }
}
:deep(.el-input__inner) {
  background: #f4f9fd;
  background-color: #f4f9fd;
  border: 1px solid #d8e0f0;
  color: #458bff;
  border-radius: 14px;
  &::placeholder {
    color: #aaaaaa;
  }
}
.wrapper {
  background: url('../../assets/images/dy/main.jpg') no-repeat center top;
  background-size: cover;

  .affiliate {
    margin: 0 auto;
    min-height: 100vh;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .game-title {
      font-family: trending;
      font-size: 36px;
      text-transform: uppercase;
      &.sub {
        font-size: 30px;
        font-weight: normal;
        font-family: Jura;
      }
      &.underline {
        background-image: linear-gradient(to right, #de4545, #db7e42);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        margin-bottom: 40px;
        &:after {
          content: '';
          width: 60px;
          height: 5px;
          background: linear-gradient(to right, #de4545, #db7e42);
          display: block;
          margin: 5px auto;
        }
      }
    }
    .affiliate-login {
      width: 95%;
      max-width: 480px;
      margin: 30px;
      // background-color: #15141b;
      // border-radius: 10px;
      // border: solid 1px #24222e;
      padding: 10px 50px;
      .el-form-item {
        margin-bottom: 30px;
      }
      :deep(.el-form-item__error) {
        padding-top: 10px;
      }
      .signlog {
        font-family: Jura;
        font-size: 14px;
        color: #31b0bf;
        display: block;
        margin: 10px auto;
        text-align: right;
      }
    }
  }
}

.image-number-point {
  position: absolute;
  width: 25px;
  height: 25px;
  border: 2px solid white;
  border-radius: 50%;
  background: #3f4eff;
  z-index: 9999;
  color: white;
  padding: 2px 6px;
  user-select: none;
  cursor: pointer;
}

:deep(.el-image__inner) {
  max-height: 100% !important;
  max-width: 100% !important;
}
.firstPage {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 20px;
  position: relative;
  background: url('../../assets/images/login/firstbg.jpg') no-repeat center
  center;
  background-size: cover;
  &.lh {
    align-items: safe center;
    padding-top: 16px;
    padding-bottom: 16px;
    .inner {
      height: unset;
      margin: 0 auto;
    }
    background: url('../../assets/images/login/lh-bg.png') no-repeat top center;
    background-color: #19326d;
    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      min-height: 0;
      .logo {
        position: static !important;
        align-self: flex-start;
        width: 140px;
        margin-bottom: 10px;
        flex-shrink: 0;
        @media (min-width: 1101px) {
          align-self: center;
          width: 190px;
        }
      }
      .first-liner {
        margin: 0 !important;
      }
      .first-liner {
        max-width: 85% !important;
        margin-left: auto !important;
        margin-right: auto !important;
        min-height: 0;
        img {
          max-height: 14vh !important;
          width: auto !important;
          margin: 0 auto;
        }
        :deep(.lh-h5-banner) {
          display: none;
        }
        @media (max-width: 1100px) {
          max-width: 75% !important;
        }
        @media (min-width: 675px) and (max-width: 1100px) {
          max-width: 55% !important;
        }
      }
      .second-liner {
        max-width: 55% !important;
        margin: 0 auto !important;
        min-height: 0;
        img {
          width: auto !important;
          max-height: 22vh !important;
          margin: 0 auto;
        }
        @media (max-width: 1100px) {
          max-width: 50% !important;
        }
        @media (min-width: 675px) and (max-width: 1100px) {
          max-width: 32% !important;
        }
        @media (min-width: 1101px) {
          max-width: 65% !important;
        }
      }
    }

    .right {
      display: flex;
      justify-content: center;
      .top {
        background: #fff !important;
        margin: 0 10px;
        margin-bottom: -1px;
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
        padding: 20px 20px 0 !important;
        .log {
          font-size: 24px !important;
          padding-bottom: 0;
        }
        @media (max-width: 768px) {
          margin: 0 1.75%;
          margin-bottom: -1px;
        }
      }

      .mid {
        position: relative;
        padding: 12px 20px;
        .top-img {
          width: 22%;
          position: absolute;
          right: 40px;
          top: 0;
          transform: translateY(-50%);
        }
      }
      .bot {
        padding: 6px;
      }
      .forget-pw {
        margin: 8px 0px;
        place-self: end;
      }
      .login-btn-grp {
        display: block;
        width: 100%;
        button {
          width: 100% !important;
          margin: 8px 0;
          border-radius: 4px;
        }
        .el-button--danger {
          background: linear-gradient(
              180deg,
              #73b2ff 0%,
              #3981ff 100%,
              #3981ff 100%
          );
        }
      }
      .contact-div {
        margin-top: 0;
        color: #3981ff;
        text-decoration: underline;
      }
    }
    .bot {
      margin-top: -1px;
      width: calc(100% - 1.1px);
    }
  }
  &.vi,
  &.kaka {
    font-family: 'Roboto';
    .loginPage .right .top .log {
      font-family: 'Roboto';
    }
    .loginPage .left {
      .second-liner {
        font-family: 'Roboto';
      }
    }
  }
  &.kaka {
    --kaka-primary: #ff4545;
    background-image: url('../../assets/images/kaka/first-bg-kaka.png');

    .el-link.el-link--primary {
      --el-link-font-color: var(--kaka-primary);
      &:hover {
        color: var(--kaka-primary);
      }
    }

    :deep(.el-input__inner) {
      background-color: #fdf4f4;
      border: 1px solid #f0d8d8;
      color: #000;
      border-radius: 14px;
      &::placeholder {
        color: #dcd5d5;
      }
    }

    .float-logo {
      position: absolute;
      top: 30px;
      left: 30px;
    }

    .loginPage {
      .right {
        .top {
          background-image: url('../../assets/images/kaka/top-kaka.png');
        }
        .bot {
          background-image: url('../../assets/images/kaka/dow-kaka.png');
        }
      }
    }

    .inner {
      max-width: 1300px;
    }

    .common-btn {
      &:not(.default-btn) {
        background-color: var(--kaka-primary);
      }
      &.default-btn {
        border-color: var(--kaka-primary);
        color: var(--kaka-primary);
      }
    }

    .loginPage {
      max-width: 1300px;
      .left {
        flex: 2;
        .first-liner {
          font-family: 'Roboto', sans-serif;
          margin-bottom: 15px;
          width: 750px;
          max-width: 750px;
        }
        .second-liner {
          width: 750px;
          max-width: 750px;
        }
      }
    }
  }
  &.ph2 {
    background-image: url('../../assets/images/ph2/ph2-login-bg-web.png');
    background-position: left center;
    .inner {
      max-width: 1600px;
      .loginPage {
        max-width: 1600px;
        .left-pseudo {
          width: 900px;
        }
        .left {
          position: absolute;
          top: 5%;
          left: 5%;
          .logo {
            width: 300px;
          }
          .first-liner,
          .second-liner {
            white-space: nowrap;
          }
          .first-liner {
            color: #fff;
            margin-bottom: 1rem;
            background-clip: unset;
            background: transparent;
            -webkit-text-fill-color: unset;
            :deep(.linear) {
              display: inline;
              color: transparent;
              background: linear-gradient(90deg, #F6D75E 0%, #F7C95A 35%, #F5A74D 70%, #F39A45 100%);
              background-clip: text;
            }
          }
        }
        .right {
          @media (min-width: 768px) {
            display: flex;
            justify-content: flex-end;
            .swiper-no-swiping {
              width: 620px;
              .top {
                padding: 32px;
              }
              .mid {
                margin: 0 11.5px;
              }
              .bot {
                padding: 15px;
              }
            }
          }
        }
      }
    }
    @media (max-width: 500px) {
      background-image: url('../../assets/images/ph2/ph2-login-bg-mobile.png');
      background-position: center;
      padding: 0 20px;
      min-height: 100dvh;
      .inner {
        padding-top: 20px;
        margin: auto auto 50px;
        .loginPage {
          gap: 2rem;
          .left {
            position: absolute;
            left: unset;
            top: 6%;
            .logo {
              width: 120px;
              left: 50%;
              top: -60%;
              transform: translateX(-50%);
            }
            .first-liner {
              font-size: 2rem;
              margin-bottom: 1rem;
            }
            .second-liner {
              font-size: 1rem;
            }
          }
          .right {
            .contact-div {
              width: auto;
            }
          }
        }
      }
      .common-btn {
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
  .inner {
    max-width: 1200px;
    width: 100%;
    margin: 50px auto;
    height: 50%;
  }
  .logo {
    width: 200px;
    img {
      width: 100%;
    }
  }
  .loginPage {
    height: 80%;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    .left {
      flex: 1;
      .first-liner,
      .second-liner {
        // max-width: 400px;
        width: 100%;
        img {
          width: 100%;
        }
      }
      .first-liner {
        margin-bottom: 3rem;
        background: linear-gradient(
            180deg,
            #f6d99e 13.1%,
            #ffe3bd 50.03%,
            #fbbd68 79.37%
        );
        text-shadow: 0px 4px 4px 0px #1c1614;
        font-size: 5rem;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        filter: drop-shadow(0px 4px 4px #1c1614);
        font-family: fzh;
      }
      .second-liner {
        font-family: fzh;
        color: #ffffff;
        font-size: 2rem;
      }
    }
    .right {
      flex: 1;
      .bg {
        width: 520px;
      }
      .top {
        background: url(../../assets/images/login/top.png) no-repeat center
        center;
        background-size: cover;
        padding: 20px;
        position: relative;
        .log {
          font-weight: bold;
          //font-family: fzh;
          font-family: Oxanium, -apple-system, BlinkMacSystemFont, Segoe UI,
          Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
          Microsoft YaHei, Arial, sans-serif;
          font-size: 32px;
          padding-left: 15px;
        }
        .topright {
          position: absolute;
          right: 30px;
          top: 18px;
          .noaccabs {
            font-size: 16px;
            color: #ffffff;
          }
          a {
            font-family: PFBold;
            font-size: 16px;
            color: #ffffff;
          }
        }
      }
      .mid {
        background: url(../../assets/images/login/mid.png) no-repeat center
        center;
        background-size: cover;
        margin: 0 10px;
        padding: 15px 20px 15px;
        .el-form {
          width: 95%;
          margin: 0 auto;
        }
      }
      .bot {
        background: url(../../assets/images/login/dow.png) no-repeat center
        bottom;
        background-size: cover;
        padding: 10px;
      }
    }
  }

  &.br2 {
    background: url('../../assets/images/br2/br2-bg.png') no-repeat center;
    height: 100vh;
    .logo {
      position: absolute;
      left: 70px;
      top: 40px;
      width: 207px;
    }

    .loginPage .left .first-liner {
      max-width: 750px;
      width: 750px;
    }

    .loginPage .left .second-liner {
      max-width: 600px;
      width: 600px;
    }

    .inner {
      max-width: 1300px;
    }

    .common-btn {
      width: 100% !important;
      background: linear-gradient(90deg, #4fffa5 0%, #10d16f 100%);
      color: #fff;
    }

    .main-img {
      display: block;
      width: 100%;
      max-width: 700px;
    }

    .left {
      margin-top: 150px;
    }

    .loginPage .right .top {
      background: url(../../assets/images/br2/top.png) no-repeat center center;
      background-size: cover;
    }

    .forget-pw {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
    }
  }

  &.ind-firstPage {
    background: url('../../assets/images/ind/ind-bg.png') no-repeat center;
    height: 100vh;
    .logo {
      position: absolute;
      left: 70px;
      top: 40px;
      width: 207px;
    }

    .loginPage .left .first-liner {
      max-width: 750px;
      width: 750px;
    }

    .loginPage .left .second-liner {
      max-width: 600px;
      width: 600px;
    }

    .inner {
      max-width: 1300px;
    }

    .common-btn {
      background: linear-gradient(180deg, #8b36f8 0%, #334ad6 100%);
      color: #fff;
    }
  }

  &.lk6 {
    background-image: url('../../assets/images/lk6/first-bg.png');
    .inner {
      max-width: 1700px;
      .loginPage {
        max-width: 1700px;
        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 3;

          .logo {
            width: 304px;
            margin-bottom: 78px;
          }

          .first-liner {
            position: relative;
            width: unset;
            background-image: linear-gradient(180deg, #002152 0%, #435583 100%);
            filter: drop-shadow(0px 4px 0px #00000040);
            font-size: 6.875rem;
            text-align: center;

            &.firstliner-lk6 {
              font-family: 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial,
              sans-serif;
              font-weight: 800;

              @media (max-width: 769px) {
                font-family: 'PingFang SC', 'Hiragino Sans GB',
                'Microsoft YaHei', '微软雅黑', 'Heiti SC',
                'WenQuanYi Micro Hei', sans-serif;
              }
            }
            &.firstliner-lk6::before {
              display: none;
            }
            &::before {
              content: attr(data-text);
              position: absolute;
              z-index: -1;
              -webkit-text-stroke: 2px #fff;
              text-stroke: 2px #fff;
            }
          }
          .second-liner-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 920px;

            .second-liner-img {
              max-width: 267px;
            }
            .second-liner-inner {
              display: flex;
              flex-direction: column;
              .second-liner {
                position: relative;
                background: linear-gradient(0deg, #367aff 0%, #4ca2ff 100%);
                background-clip: text;
                filter: drop-shadow(0px 1.74px 0px #00000040);
                color: transparent;
                line-height: 1.5;
                font-size: 3.125rem;
                white-space: pre-line;
                &::before {
                  content: attr(data-text);
                  position: absolute;
                  z-index: -1;
                  -webkit-text-stroke: 0.87px #fff;
                  text-stroke: 0.87px #fff;
                }

                &.secondliner-lk6::before {
                  display: none;
                }
              }
              .second-liner-contact-info {
                display: flex;
                align-items: center;
                .second-liner-contact-info__icon {
                  max-width: 64px;
                  margin-right: 6px;
                }
                .second-liner-contact-info__text-wrapper {
                  display: flex;
                  flex-direction: column;
                  span {
                    font-size: 1.75rem;
                    color: #35648f;
                    font-weight: 500;
                  }
                  a {
                    font-size: 1.6rem;
                    color: #57a4ff;
                    font-weight: 600;
                  }
                }
              }
            }
          }
        }
        .right {
          flex: 2;
          .bg {
            background: #f7f9fc;
            box-shadow: 0px 0px 34px 0px #00000040;
            border-radius: 30px;
            padding: 40px 50px;
            width: 600px;
            .top {
              background-image: none;
              padding: 0;
              margin-bottom: 60px;
              .log {
                text-align: center;
              }
              .lang-toggle {
                position: absolute;
                right: 0;
                top: 0;
                max-width: 108px;
              }
            }
            .mid {
              margin: 0;
              padding: 0;
              background-image: none;
              .el-form {
                width: 100%;
                .el-form-item {
                  &.is-required {
                    .el-input {
                      :deep(.el-input__prefix) {
                        .prefix-wrapper {
                          span {
                            &::after {
                              content: '*';
                              color: #d92020;
                            }
                          }
                        }
                      }
                    }
                  }

                  .el-input {
                    :deep(.el-input__inner) {
                      height: 60px;
                      padding-left: 164px;
                      background: linear-gradient(
                          180deg,
                          #ffffff 0%,
                          #e3efff 100%
                      );
                      box-shadow: 0px 2px 2px 0px #ffffffcc inset,
                      0px 2px 0px 0px #c6d9ff;
                      border-radius: 30px;
                      border: none;
                    }
                    :deep(.el-input__prefix) {
                      .prefix-wrapper {
                        display: flex;
                        align-items: center;
                        height: inherit;
                        padding-left: 16px;
                        padding-top: 5px;
                        img {
                          max-width: 36px;
                          margin-right: 8px;
                        }
                        span {
                          font-size: 1.125rem;
                          color: #424f72;
                        }
                      }
                      .prefix-icon {
                        display: none;
                      }
                    }
                    :deep(.el-input__suffix) {
                      .el-input__suffix-inner {
                        display: flex;
                        align-items: center;
                        height: inherit;
                        padding: 8px 12px;
                      }
                    }
                  }
                }
                .forget-pw {
                  margin: 49px 0;
                  text-align: end;
                }
                .reg-btn-grp {
                  margin-top: 63px;
                }
                .common-btn {
                  background: radial-gradient(
                      103.75% 103.75% at 50% -3.75%,
                      #94c3ff 0%,
                      #4b91f5 100%
                  );
                  box-shadow: 0px 2px 0px 0px #9ab0ff70;
                  border: 1px solid #ffffff;
                  border-radius: 50px;
                  height: 68px;
                  font-size: 1.25rem;
                  &.default-btn {
                    background: linear-gradient(
                        180deg,
                        #f4f7fb 0%,
                        #c5dcf8 100%
                    );
                    color: #7a8eb9;
                    border: none;
                    box-shadow: none;
                  }
                }
              }
            }
            .bot {
              display: none;
            }
          }
        }
      }
    }
  }
}

.flex-c-center-div {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-bottom: 10px;
  text-align: center;

  .contact-div {
    margin-top: 10px;
    width: 50%;
    padding: 10px 20px 0px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
    &:active {
      filter: brightness(0.85);
      transform: translate(0px, 1px);
    }
  }
}

.auth-container {
  margin: 20px;

  .auth-title {
    font-size: 18px;
    font-weight: 600;
    margin: 30px 0 15px 0;
  }
}

@media (max-width: 1100px) {
  .firstPage {
    height: auto;
    min-height: 100vh;
    .inner {
      padding-top: 100px;
    }

    .loginPage {
      flex-direction: column;
    }

    &.lh {
      height: auto;
      min-height: 100vh;
      .inner {
        padding-top: 0;
        height: 100%;
      }
      .loginPage {
        height: 100%;
        .left {
          flex: 0 0 auto;
          min-height: 0;
          justify-content: center;
        }
        .right {
          flex: 1;
          min-height: 0;
          justify-content: center;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .firstPage {
    height: auto;
    min-height: 100vh;
    .inner {
      padding-top: 50px;
    }
    &.lh {
      height: auto;
      min-height: 100vh;
      .inner {
        padding-top: 0;
        height: 100%;
      }
      .loginPage {
        height: 100%;
        gap: 12px !important;
        .left {
          flex: 0 0 auto;
          min-height: 0;
          justify-content: center;
          width: 100%;
          .logo {
            width: fit-content;
            margin-bottom: unset;
            img {
              height: 30px;
              width: auto;
            }
          }
          .first-liner {
            width: 100%;
            max-width: 100% !important;
            margin-top: -10px !important;
            :deep(.lh-web-banner) {
              display: none;
            }
            :deep(.lh-h5-banner) {
              display: block;
              width: 100%;
              height: auto;
            }
          }
          .second-liner {
            display: none;
          }
        }
        .right {
          flex: 1;
          min-height: 0;
          justify-content: center;
          .mid .top-img {
            display: none;
          }
        }
      }
    }
    .loginPage {
      flex-direction: column;
      gap: 60px;
      .right {
        width: 100%;
        .bg {
          width: 100%;
        }
        .top {
          padding: 15px;
          background-size: 100%;
          background-position: bottom;
          min-height: 13vw;
          .log {
            font-size: 20px;
          }
          .topright {
            right: 20px;
            top: 10px;
          }
        }
        .mid {
          background-size: 100% 100%;
          margin: 0;
        }
        .bot {
          background-size: 100%;
          background-position: top;
          padding: 4px 20px;
        }
      }
    }
    .logo {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 120px;
    }

    &.ind-firstPage {
      .logo {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 150px;
      }

      .loginPage {
        padding-top: 30px;
      }
      .loginPage .left {
        width: calc(100% - 20px);
      }
      .loginPage .left .first-liner {
        max-width: none;
        width: 100%;
      }

      .loginPage .left .second-liner {
        max-width: none;
        width: 100%;
      }

      .common-btn {
        background: linear-gradient(180deg, #8b36f8 0%, #334ad6 100%);
      }
    }

    &.lk6 {
      min-height: 100dvh;
      align-items: flex-start;
      background-image: url('../../assets/images/lk6/first-bg-mobile.png');
      padding: 16px;
      background-size: 100% 100%;
      .inner {
        height: unset;
        .loginPage {
          gap: 2rem;
          .left {
            .logo {
              margin-bottom: unset;
              width: 127px;
              left: 14px;
            }
            .first-liner {
              font-size: 2.5rem;
              margin-bottom: 0.5rem;
              &::before {
                -webkit-text-stroke: 1px #fff;
                text-stroke: 1px #fff;
              }
            }
            .second-liner-wrapper {
              width: 100%;
              .second-liner-img {
                display: none;
              }
              .second-liner-inner {
                width: 100%;
                .second-liner {
                  font-size: 1.3125rem;
                  text-align: center;
                  &::before {
                    -webkit-text-stroke: 0.38px #fff;
                    text-stroke: 0.38px #fff;
                  }
                }
                .second-liner-contact-info {
                  position: absolute;
                  right: 14px;
                  top: 20px;
                  aspect-ratio: 127 / 60;
                  .second-liner-contact-info__icon {
                    width: 10vw;
                    max-width: 36px;
                  }
                  .second-liner-contact-info__text-wrapper {
                    span {
                      font-size: 0.875rem;
                    }
                    a {
                      font-size: 0.875rem;
                    }
                  }
                }
              }
            }
          }
          .right {
            .bg {
              padding: 25px 12px;
              width: 100%;
              margin-bottom: 46px;
              background: #ffffff80;
              // box-shadow: 0px 4px 24.9px 0px #DAECFF inset, 0px 0px 5.9px 0px #93C7FF69;
              box-shadow: unset;
              backdrop-filter: blur(5.199999809265137px);
              border: 1px solid #c6d9ff;

              .top {
                margin-bottom: 1rem;
                min-height: unset;
                .log {
                  font-size: 1rem;
                  line-height: 23px;
                  color: #424f72;
                }
                .lang-toggle {
                  max-width: 66px;
                }
              }
              .mid {
                .el-form {
                  .el-form-item {
                    :deep(.el-form-item__label) {
                      font-size: 0.75rem;
                      line-height: 1;
                      margin-bottom: 8px;
                      color: #424f72;
                      &::before {
                        display: none;
                      }
                      &::after {
                        content: '*';
                        color: #d92020;
                        margin-left: 4px;
                      }
                    }
                    .el-input {
                      :deep(.el-input__inner) {
                        height: 48px;
                        padding-left: 40px;
                        border-radius: 7px;
                        background: #fff;
                        box-shadow: 0px 0px 5px 0px #86b8ff inset,
                        0px 2px 0px 0px #9ab0ff70;
                      }
                      :deep(.el-input__prefix) {
                        display: flex;
                        align-items: center;
                        padding-left: 10px;
                        .prefix-wrapper {
                          display: none;
                        }
                        .prefix-icon {
                          display: block;
                          max-width: 18px;
                        }
                      }
                    }
                  }
                  .forget-pw {
                    margin: 0;
                    .el-link {
                      --el-color-primary: #7a80a1;
                    }
                  }
                  .login-btn-grp,
                  .reg-btn-grp {
                    display: none;
                  }
                }
              }
            }
            .bottom-btn-grp {
              display: flex;
              flex-direction: column;
              gap: 20px;
              .common-btn {
                width: 100%;
                background: radial-gradient(
                    103.75% 103.75% at 50% -3.75%,
                    #94c3ff 0%,
                    #4b91f5 100%
                );
                box-shadow: 0px 2px 0px 0px #9ab0ff70;
                border: 1px solid #ffffff;
                border-radius: 30px;
                height: 48px;
                font-size: 1rem;
                &.default-btn {
                  background: linear-gradient(180deg, #f4f7fb 0%, #c5dcf8 100%);
                  color: #424f72;
                  border: none;
                  box-shadow: none;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .wrapper {
    .affiliate {
      .game-title {
        &.underline {
          font-size: 25px;
        }
      }
      .description {
        flex-direction: column-reverse;
      }

      .steps {
        display: flex;
        flex-direction: column;
        background: unset;
        justify-content: center;
        gap: 10px;
        padding: 0;
        .step {
          display: flex;
          color: #ffffff;
          background: #1e1b2e;
          padding: 10px;
          gap: 25px;
          justify-content: space-evenly;
          align-items: center;
          .stepdesc {
            flex-direction: row;
            gap: 5px;
            flex: 3;
            justify-content: flex-start;
          }
          .game-title {
            font-family: Wave;
            color: #ffd200;
            flex: 1;
            text-align: right;
          }
        }
      }
    }
  }
  .swiper-slide {
    max-height: unset;
    overflow: auto;
  }
}
@media (max-height: 1050px) and (min-width: 769px) and (max-width: 1100px) {
  .firstPage {
    .inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100% !important;
      padding-top: 0 !important;
      margin-top: 0 !important;
    }
    .loginPage {
      height: auto !important;
      flex: 0 0 auto !important;
    }
    .loginPage .left {
      .first-liner,
      .second-liner {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
// PH2 LiveChat widget: LiveChat's own script sizes #chat-widget-container inline on
// every state change, so only an !important rule (not an inline/JS style) sticks.
#chat-widget-container {
  width: 450px !important;
}

.dialog400 {
  width: 100%;
  max-width: 400px;

  #loadDiv {
    display: flex;
    flex-direction: column;
    margin-top: -30px;
  }
}

.overlapParent {
  display: grid;
  grid-template-columns: 1fr;
  .el-image {
    align-self: flex-start;
  }
}

.el-image {
  grid-row-start: 1;
  grid-column-start: 1;
}

#dragInput {
  height: 25px;
  padding: 0px 10px;
  pointer-events: none;
}

#dragInput::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  pointer-events: auto;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #458bff;
  cursor: pointer;
}

#dragInput::-moz-range-thumb {
  pointer-events: auto;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

#dragInput::-ms-thumb {
  pointer-events: auto;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

@media (max-width: 768px) {
  .dialog400 {
    width: 80%;
  }
  .el-dialog {
    --el-dialog-padding-primary: 10px;

    .el-button {
      margin-top: 10px !important;
      // margin-bottom: -10px;
    }

    .el-dialog__header {
      margin: 10px 0;
    }
  }

  .verification-title {
    font-size: 0.8rem;
  }
}


#captchaContainer {
  width: 100%;

  .geetest_box {
    width: 120% ;
  }

  .geetest_box_wrap .geetest_box .geetest_header .geetest_title{
    font-size: 10px !important;
  }

  .geetest_captcha.geetest_dark .geetest_holder .geetest_content,
  .geetest_captcha.geetest_dark.geetest_freeze_wait .geetest_holder .geetest_content {
    background-image: linear-gradient(180deg, #ecf3fd, 0%, #ecf3fd 100%) !important;
    border-color: #424f72;
  }

  .geetest_captcha.geetest_dark .geetest_holder .geetest_content .geetest_tip_container .geetest_tip {
    color: #424f72;
    font-family: "PingFang SC" !important;
  }

  .geetest_captcha.geetest_dark.geetest_lock_success
  .geetest_content
  .geetest_tip_container
  .geetest_tips_wrap
  .geetest_tip {
    color: #39c522 !important;
  }
}
</style>

<style lang="scss" scoped>
.ph2-cs-entry {
  position: fixed;
  right: 20px;
  bottom: 30px;
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 24px;
  background: #458bff;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  &:hover {
    opacity: 0.9;
  }
}
// Replaced by the LiveChatWidget popup; kept for reference.
// .ph2-cs-tip {
//   margin: 0 0 16px;
//   color: #666666;
//   line-height: 1.5;
// }
// .ph2-cs-item {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 10px;
//   padding: 10px 0;
//   border-bottom: 1px solid #eeeeee;
//   .ph2-cs-type {
//     font-weight: bold;
//   }
//   .ph2-cs-account {
//     color: #666666;
//     word-break: break-all;
//   }
// }
</style>
